var productsStoreModule = {
    state: {
        products: []
    },
    actions: {
        addProductData: function(context, data) {
            context.commit('addProduct', data);
        },
        fetchProduct: function (context, productId) {
            if (context.state.products[productId] != undefined) {
                return true;
            }

            $.post(Eshop.options.baseUrl + 'rshop-api/products/map', {product_id: productId}, function (response) {
                context.commit('addProduct', response.result.map);
            }.bind(this), 'json').fail(function() {
                Event.dispatch('ProductsStoreModule.failedFetchProduct', productId);
            });
        }
    },
    mutations: {
        addProduct: function (state, product) {
            state.products.push(product);
        }
    },
    getters: {
        products: function (state) {
            return state.products;
        }
    }
};

var ProductComponent = Vue.component('product', {
    props: ['productId'],
    components: {
        'product-variation': ProductVariationComponent,
        'product-cart': ProductCartComponent,
        'product-free-shipping': ProductFreeShippingComponent,
        'product-services': ProductServicesComponent
    },
    data: function () {
        return {
        };
    },
    created: function() {
        this.initializeProduct();
    },
    methods: {
        initializeProduct() {
            var index = this.index;

            if (index != -1) {
                return;
            }

            $(function() {
                this.$store.dispatch('fetchProduct', this.productId);
            }.bind(this));
        }
    },
    computed: {
        index: function() {
            return _.indexOf(_.pluck(this.$store.state.products.products, 'id'), this.productId);
        },
        product: function() {
            var index = this.index;

            if (index == -1) {
                return {
                    id: null,
                    name: '',
                    price: 0,
                    price_vat: 0
                };
            }

            return this.$store.state.products.products[index];
        },
        isAvailable: function() {
            return this.product.is_available;
        },
        productName: function() {
            return this.product ? this.product.name : '';
        },
        productPrice: function() {
            return this.product ? Format.price(this.product.price) : 0;
        },
        productPriceVat: function () {
            return this.product ? Format.price(this.product.price_vat) : 0;
        },
        productPriceFinal: function () {
            return Eshop.options.pricesWithVat ? this.productPriceVat : this.productPrice;
        },
        productOldPrice: function () {
            return this.product ? Format.price(this.product.old_price) : 0;
        },
        productOldPriceVat: function () {
            return this.product ? Format.price(this.product.old_price_vat) : 0;
        },
        productOldPriceFinal: function () {
            return Eshop.options.pricesWithVat ? this.productOldPriceVat : this.productOldPrice;
        },
        productModel: function() {
            return this.product ? this.product.model : '';
        },
        isAction: function() {
            return this.product.price < this.product.old_price;
        }
    },
    watch: {
        productId: function() {
            this.initializeProduct();
        }
    },
});
